import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useMutation } from '@apollo/client/react'
// components
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import BusinessEntityModal from 'components/Modals/BusinessEntityModal'
import BusinessProcessesTree from 'components/PageComponents/Settings/BusinessProcesses/components/Tree/index'
import { CreateBusinessProcessButton } from 'components/CTAs'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// context
import { BusinessProcessesAPIContext } from 'containers/BusinessProcesses/layers/API'
// graphql
import { BUSINESS_PROCESSES_SELECT_QUERY } from 'graphql/businessProcess/queries'
import { BUSINESS_PROCESS_CREATE_MUTATION, BUSINESS_PROCESS_UPDATE_MUTATION } from 'graphql/businessProcess/mutations'
// constants
import { ENTITIES } from 'constants/entities'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
import { businessProcessProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const BusinessProcesses: React.FC = () => {
  const [createMutation] = useMutation(BUSINESS_PROCESS_CREATE_MUTATION)
  const [updateMutation] = useMutation(BUSINESS_PROCESS_UPDATE_MUTATION)

  const { refetch, lastPosition, isLoading } = React.useContext(BusinessProcessesAPIContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Business Processes</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} CTA={<CreateBusinessProcessButton />}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <BusinessProcessesTree />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>

      <BusinessEntityModal
        {...businessProcessProps}
        refetch={refetch}
        lastPosition={lastPosition}
        createMutation={createMutation}
        updateMutation={updateMutation}
        entityType={ENTITIES.BUSINESS_PROCESS}
        query={BUSINESS_PROCESSES_SELECT_QUERY}
      />
    </>
  )
}

export default BusinessProcesses
